import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validate Firebase configuration
const validateFirebaseConfig = () => {
  const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'] as const;
  const missingKeys: string[] = [];

  for (const key of requiredKeys) {
    const value = firebaseConfig[key];
    if (!value || value.includes('your_') || value.includes('_here')) {
      missingKeys.push(key);
    }
  }

  if (missingKeys.length > 0) {
    console.error(
      '❌ Firebase configuration is incomplete. Please update your .env file with valid Firebase credentials.\n' +
      `Missing or invalid: ${missingKeys.join(', ')}\n` +
      'Get your credentials from: https://console.firebase.google.com/'
    );
  }
};

// Validate configuration in development
if (import.meta.env.DEV) {
  validateFirebaseConfig();
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
